import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, CircularProgress, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import AppButton from '../../../../components/designe/buttons/app-button/AppButton';
import { useRegisterPageContainerError } from '../../../../components/layout/page-container/page-container-error-handler';
import { useStyles } from './MeasurementsView.styles';
import MeasurementFieldRow from './measurement-field-row/MeasurementFieldRow';
import RecordMeasurementModal from './record-measurement-modal/RecordMeasurementModal';
import { useMeasurementsView } from './useMeasurementsView';

export default function MeasurementsView() {
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const {
    isLoading,
    isError,
    errors,
    refetch,
    weightDisplay,
    heightDisplay,
    activeParameter,
    activeLatestMeasurement,
    handleRecordClick,
    handleModalClose,
    handleModalSuccess,
  } = useMeasurementsView();

  useRegisterPageContainerError({
    errors,
    isLoading,
    hasData: !isError && !isLoading,
    onRetry: refetch,
  });

  return (
    <div className={classes.wrapper}>
      {isLoading ? (
        <Box className={classes.loadingBox}>
          <CircularProgress />
        </Box>
      ) : null}

      {isError && !isLoading ? (
        <Box className={classes.errorBox}>
          <Typography color="error">{t('common.error')}</Typography>
          <AppButton onClick={() => refetch()}>{t('common.retry')}</AppButton>
        </Box>
      ) : null}

      {!isLoading && !isError ? (
        <Box className={classes.content}>
          <MeasurementFieldRow
            label={t('settings.measurements.weight')}
            value={weightDisplay}
            onRecordClick={() => handleRecordClick('weight')}
            viewItemClassName={classes.viewItem}
          />
          <MeasurementFieldRow
            label={t('settings.measurements.height')}
            value={heightDisplay}
            onRecordClick={() => handleRecordClick('height')}
            viewItemClassName={classes.viewItem}
          />
        </Box>
      ) : null}

      {activeParameter !== null ? (
        <RecordMeasurementModal
          open
          parameter={activeParameter}
          latestMeasurement={activeLatestMeasurement}
          onClose={handleModalClose}
          onSuccess={handleModalSuccess}
        />
      ) : null}
    </div>
  );
}
